import InsuredToSave from '../../../../../common/common/models/MID/InsuredToSave'

export default class SaveInsuredsDentalRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: "23423-643hbf-74834hj". */
  quotationId!: string

  /** Lista de asegurados a guardar. */
  insureds!: InsuredToSave[]

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.insureds = data.insureds?.map((insured: any) => new InsuredToSave(insured))
  }
}
